/*****
 * Created with WebStorm.
 * Date : 2018/1/25.
 * Author : Ztr.
 * Func : 全局封装Axios
 ******/
import Axios from 'axios'
import store from '../store/index'
import qs from "qs";
import api from "../config/api";
import Cookies from 'js-cookie';
import router from '../router'
import {
  Toast,
  Indicator,
  MessageBox
} from 'mint-ui';
//全局请求接口配置信息
Axios.defaults.baseURL = api.base;
// Axios.defaults.headers['Content-Type'] = 'multipart/form-data';
Axios.defaults.headers['Content-Type'] = "application/json";
Axios.defaults.timeout = 60 * 1000;
// Axios.defaults.headers.common['X-Requested-with'] = "XMLHttpRequest";
// Axios.defaults.headers.common['yhToken'] = "";
// Axios.defaults.headers.common['Authorization'] = "";
let _isShow = false;
let _toastType = 0;
const _appId = window.ServerConfig.appId;
const _deviceId = window.ServerConfig.deviceId;
const _platId = window.ServerConfig.version=='jiguan'?window.ServerConfig.platId:Cookies.get('platId');
// Request拦截器
Axios.interceptors.request.use(
  config => {
    //处理全局参数注入Token
    let _timestamp = +new Date() + "";
    if(['/login2','/login'].indexOf(router.currentRoute.path) >= 0) {
      Cookies.remove('sessionId');
    }
    if (config.method === "post") {
      config.data["appId"] = _appId || "";
      config.data["deviceId"] = _deviceId || "";
      config.data["signType"] = "MD5";
      // config.data["encryptType"] = "AES";
      config.data["isEncrypt"] = "0";
      config.data["termType"] = api.termType;
      config.data["timestamp"] = _timestamp;
      config.data["version"] = "1.0.0";
      config.data["termId"] = "1234";
      config.data["alg"] = "AES";
      config.data["sign"] = "rasfs2334214fasf";
      config.data["platId"] = store.getters.platId || _platId;
      config.data["sessionId"] = store.getters.token || "";
      // console.error(store.getters.platId)
      // if (store.getters.token) {
      //   config.data['token'] = store.getters.token
      // }
      // if (api.contentType === 'application/x-www-form-urlencoded') {
      // form提交时需转换数据为字符串
      // config.data = qs.stringify(config.data)
      // }
    }
    if (config.method === "get") {
      if (store.getters.token) {
        config.param['token'] = store.getters.token
      }
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

//Response拦截器
Axios.interceptors.response.use(
  response => {
    //处理关闭loading
    response.config.isLoading && (Indicator.close())
    //axios默认请求判断状态
    if (response.status === 200) {
      //成功过滤处理，返回数据对象，属性信息走配置文件的配置
      if (!api.responseConfig.isOK(response.data) || api.responseConfig.errorCodes.indexOf(response.data[api.responseConfig['code']]) >= 0) {
        //请求出错，统一处理
        if (!_isShow) {
          _isShow = true;
          if(_toastType == 0){
            Toast({
              message: `${response.data[api.responseConfig.msg] || '请求数据出错'}`,
              duration: 2000
            });
          }else{
            MessageBox.alert(`${response.data[api.responseConfig.msg] || '请求数据出错'}`)
          }

          // 清除登录设置的session
          console.log(router)
          if (api.responseConfig.errorCodes.indexOf(response.data[api.responseConfig['code']]) >= 0) {
            Cookies.remove('sessionId')
            Cookies.remove('userToken'+store.getters.platId)
            Cookies.remove('userInfo')
            Cookies.remove('userId')
            store.commit('setUserInfo', '')
            store.commit('setToken', '')
            store.commit('setHospitalInfo', '')
            store.commit('setUid', '')
          }
          setTimeout(() => {
            api.responseConfig.errorCallback(store, router, response.data)
            _isShow = false
          }, 1200);
        }
        return Promise.reject(response.data);
      } else {
        return Promise.resolve(response.data[api.responseConfig.data])
      }
    } else {
      return Promise.reject(response.data[api.responseConfig.data])
    }
  },
  error => {
    //处理关闭loading
    error.config.isLoading && (Indicator.close())
    if (error.response) {
      //处理错误状态码
      switch (error.response.status) {
        case 401:
          break;
        default:
          break;
      }
    }
    return Promise.reject(error.response.data);
  });

//包装https请求方法，做统一的请求控制
export default function https({
  url = api.url,
  isLoading = true,
  method = 'POST',
  serviceId = '',
  param = {},
  pageParam = null,
  toastType = 0,
  loadingTxt = ''
}) {
  _toastType = toastType;
  if (isLoading) {
    Indicator.open({
      text: loadingTxt || '数据处理中...'
    })
  }
  return new Promise((resolve, reject) => {
    let _axiosConfig = {
      method: method,
      param: {},
      data: {},
      url: url,
      isLoading
    };
    if (method.toUpperCase() === 'GET') {
      _axiosConfig['param']['serviceId'] = serviceId;
      _axiosConfig['param']['param'] = param;
      pageParam && (_axiosConfig['param']['pageParam'] = pageParam);
    } else {
      _axiosConfig['data']['serviceId'] = serviceId;
      _axiosConfig['data']['param'] = param;
      pageParam && (_axiosConfig['data']['pageParam'] = pageParam);
    }
    Axios(_axiosConfig).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
};



// WEBPACK FOOTER //
// ./src/utils/https.js